module.exports = __webpack_public_path__ + "img/file-pdf.05ccda42.svg";